/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectKioskPlan from 'modules/me/select-kiosk-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import { hasScheduledChanges } from 'state/current-kiosk/selectors';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ScheduledChangesNotice from 'modules/me/kiosk/scheduled-changes-notice';

const EditPlan = (props) => {
    return (
        <Box>
            <DocumentHead title='Manage Customer Self Checkout Plan Billing - Tower Systems' />
            <Topbar title='Customer Self Checkout Plan' subTitle='Manage your Customer Self Checkout subscription' selected='kiosk'>
                <Button primary link='/dashboard/kiosk'>
                    View Subscription Details
                </Button>
            </Topbar>
            {props.hasScheduledChanges && (
                <Box marginBottom='xxlarge'>
                    <ScheduledChangesNotice></ScheduledChangesNotice>
                </Box>
            )}
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Customer Self Checkout plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a Customer Self Checkout plan below to view
                            the estimated plan price.
                        </Text>
                    </Box>
                    <Box>
                        <SelectKioskPlan />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(EditPlan);
